import { IOptionType } from "./IMasterDataState";

export interface IScheduleState {
  schedule_overall_info: any;
  slots?: IScheduleSlotsState;
  location?: IScheduleLocationState;
  projects?: IScheduleProjectsState;
  subProjects?: IScheduleSubProjectsState;
  empDetails?: IScheduleEmpSche;
  totalCounts?: number;
  leavesInfo?: IScheduleLeavesState;
  isUpdateSuccess?: boolean;
  empScheduleDetails?: IScheduleDownloadState;
  workTypes?: IScheduleWorkType;
  leads?: IScheduleLeadsTypes;
  employees_list?: any;
  weeks_range_info: any;
}

interface IScheduleWorkType {
  data?: IScheduleWorkTypeData[];
  error?: string;
  message?: string;
  status?: string;
}

interface IScheduleWorkTypeData {
  id?: number;
  name?: string;
  slot_type_name?: string;
}

export interface IScheduleSlotsState {
  data?: IScheduleSlotData[];
  error?: string;
  message?: string;
  status?: string;
}

export interface IScheduleDownloadState {
  data?: ScheduleResponse[];
  error?: string;
  message?: string;
  status?: string;
}

interface IScheduleSlotData {
  id?: number;
  name?: string;
  slot_type?: string;
}

export interface IScheduleLocationState {
  data?: IScheduleLocationData[];
  error?: string;
  message?: string;
  status?: string;
}

export interface IScheduleLeadsTypes {
  data?: IScheduleLeadsData[];
  error?: string;
  message?: string;
  status?: string;
}

interface IScheduleLeadsData {
  employee_id?: string;
  entity_id?: string;
  name?: string;
  employee_code?: string;
  phone_number?: string;
  team?: string;
  designation?: string;
}

interface IScheduleLocationData {
  id?: number;
  name?: string;
  address?: string;
  center_location?: string;
  polygon_locations?: any;
}

export interface IScheduleProjectsState {
  data?: IScheduleProjectsData[];
  error?: string;
  message?: string;
  status?: string;
}

export interface IScheduleSubProjectsState {
  data?: IScheduleProjectsData[];
  error?: string;
  message?: string;
  status?: string;
}

interface IScheduleProjectsData {
  id?: number;
  name?: string;
}

export interface IScheduleEmpSche {
  data?: IScheduleEmpScheData[];
  error?: string;
  message?: string;
  status?: string;
}

interface IScheduleEmpScheData {
  add_employee_list?: AddEmpList[];
  schedule_responses?: ScheduleResponse[];
  search_list?: AddEmpList[];
  total_count?: number;
  weekoffs_leaves_count?: ScheduleWeekOffsCount[];
}

interface ScheduleWeekOffsCount {
  date?: string;
  leave_count?: number;
  weekoff_count?: number;
}

interface AddEmpList {
  employee_id?: string;
  name?: string;
}

interface ScheduleResponse {
  employee_id?: string;
  name?: string;
  project_id?: number;
  days?: any;
  sub_projects?: any;
  sub_projects_id?: any;
}

export interface IScheduleLeavesState {
  data?: IScheduleLeavesData;
  error?: string;
  message?: string;
  status?: string;
}

export interface IScheduleLeavesData {
  weekoff_list?: any;
  leave_list?: any;
}

export enum IScheduleActionTypes {
  UPDATE_SCHEDULE_SELECTED_TAB = "UPDATE_SCHEDULE_SELECTED_TAB",

  FETCH_SCHEDULE_SLOTS_DETAILS_REQUEST = "FETCH_SCHEDULE_SLOTS_DETAILS_REQUEST",
  FETCH_SCHEDULE_SLOTS_DETAILS_SUCCESS = "FETCH_SCHEDULE_SLOTS_DETAILS_SUCCESS",
  FETCH_SCHEDULE_SLOTS_DETAILS_FAILURE = "FETCH_SCHEDULE_SLOTS_DETAILS_FAILURE",

  FETCH_SCHEDULE_LOCATION_DETAILS_REQUEST = "FETCH_SCHEDULE_LOCATION_DETAILS_REQUEST",
  FETCH_SCHEDULE_LOCATION_DETAILS_SUCCESS = "FETCH_SCHEDULE_LOCATION_DETAILS_SUCCESS",
  FETCH_SCHEDULE_LOCATION_DETAILS_FAILURE = "FETCH_SCHEDULE_LOCATION_DETAILS_FAILURE",

  FETCH_SCHEDULE_PROJECTS_DETAILS_REQUEST = "FETCH_SCHEDULE_PROJECTS_DETAILS_REQUEST",
  FETCH_SCHEDULE_PROJECTS_DETAILS_SUCCESS = "FETCH_SCHEDULE_PROJECTS_DETAILS_SUCCESS",
  FETCH_SCHEDULE_PROJECTS_DETAILS_FAILURE = "FETCH_SCHEDULE_PROJECTS_DETAILS_FAILURE",

  FETCH_SCHEDULE_WORK_TYPE_DETAILS_REQUEST = "FETCH_SCHEDULE_WORK_TYPE_DETAILS_REQUEST",
  FETCH_SCHEDULE_WORK_TYPE_DETAILS_SUCCESS = "FETCH_SCHEDULE_WORK_TYPE_DETAILS_SUCCESS",
  FETCH_SCHEDULE_WORK_TYPE_DETAILS_FAILURE = "FETCH_SCHEDULE_WORK_TYPE_DETAILS_FAILURE",

  FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_REQUEST = "FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_REQUEST",
  FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_SUCCESS = "FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_SUCCESS",
  FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_FAILURE = "FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_FAILURE",

  FETCH_ALL_EMP_SCHEDULE_DETAILS_REQUEST = "FETCH_ALL_EMP_SCHEDULE_DETAILS_REQUEST",
  FETCH_ALL_EMP_SCHEDULE_DETAILS_SUCCESS = "FETCH_ALL_EMP_SCHEDULE_DETAILS_SUCCESS",
  FETCH_ALL_EMP_SCHEDULE_DETAILS_FAILURE = "FETCH_ALL_EMP_SCHEDULE_DETAILS_FAILURE",

  UPDATE_TOTAL_SCHEDULE_COUNT = "UPDATE_TOTAL_SCHEDULE_COUNT",
  RESET_TOTAL_SCHEDULE_COUNT = "RESET_TOTAL_SCHEDULE_COUNT",

  FETCH_ALL_EMP_LEAVES_INFO_REQUEST = "FETCH_ALL_EMP_LEAVES_INFO_REQUEST",
  FETCH_ALL_EMP_LEAVES_INFO_SUCCESS = "FETCH_ALL_EMP_LEAVES_INFO_SUCCESS",

  DOWNLOAD_EMP_SCHE_DETAILS_REQUEST = "DOWNLOAD_EMP_SCHE_DETAILS_REQUEST",
  DOWNLOAD_EMP_SCHE_DETAILS_SUCCESS = "DOWNLOAD_EMP_SCHE_DETAILS_SUCCESS",

  UPDATE_EMP_SCHE_DETAILS_REQUEST = "UPDATE_EMP_SCHE_DETAILS_REQUEST",
  UPDATE_EMP_SCHE_DETAILS_SUCCESS = "UPDATE_EMP_SCHE_DETAILS_SUCCESS",

  FETCH_SCHEDULE_LEADS_DETAILS_REQUEST = "FETCH_SCHEDULE_LEADS_DETAILS_REQUEST",
  FETCH_SCHEDULE_LEADS_DETAILS_SUCCESS = "FETCH_SCHEDULE_LEADS_DETAILS_SUCCESS",
  FETCH_SCHEDULE_LEADS_DETAILS_FAILURE = "FETCH_SCHEDULE_LEADS_DETAILS_FAILURE",

  FETCH_EMPLOYEES_FILTERED_REQUEST = "FETCH_EMPLOYEES_FILTERED_REQUEST",
  FETCH_EMPLOYEES_FILTERED_SUCCESS = "FETCH_EMPLOYEES_FILTERED_SUCCESS",
  FETCH_EMPLOYEES_FILTERED_FAILURE = "FETCH_EMPLOYEES_FILTERED_FAILURE",

  FETCH_REQUESTED_RESOURCES_LIST_REQUEST = "FETCH_REQUESTED_RESOURCES_LIST_REQUEST",
  FETCH_REQUESTED_RESOURCES_LIST_SUCCESS = "FETCH_REQUESTED_RESOURCES_LIST_SUCCESS",
  FETCH_REQUESTED_RESOURCES_LIST_FAILURE = "FETCH_REQUESTED_RESOURCES_LIST_FAILURE",

  FETCH_EVENT_REQUEST_LIST_REQUEST = "FETCH_EVENT_REQUEST_LIST_REQUEST",
  FETCH_EVENT_REQUEST_LIST_SUCCESS = "FETCH_EVENT_REQUEST_LIST_SUCCESS",
  FETCH_EVENT_REQUEST_LIST_FAILURE = "FETCH_EVENT_REQUEST_LIST_FAILURE",

  FETCH_WEEKS_RANGE_LIST_REQUEST = "FETCH_WEEKS_RANGE_LIST_REQUEST",
  FETCH_WEEKS_RANGE_LIST_SUCCESS = "FETCH_WEEKS_RANGE_LIST_SUCCESS",
  FETCH_WEEKS_RANGE_LIST_FAILURE = "FETCH_WEEKS_RANGE_LIST_FAILURE",

  FECTH_UNSCHEDULED_EMPLOYEES_LIST_REQUEST = "FECTH_UNSCHEDULED_EMPLOYEES_LIST_REQUEST",
  FETCH_UNSCHEDULED_EMPLOYEES_LIST_SUCCESS = "FETCH_UNSCHEDULED_EMPLOYEES_LIST_SUCCESS",
  FETCH_UNSCHEDULED_EMPLOYEES_LIST_FAILURE = "FETCH_UNSCHEDULED_EMPLOYEES_LIST_FAILURE",
}

export type IScheduleSlotsCreator = {
  type?: string;
  payload?: IScheduleSlotsState;
};

export type IScheduleLocationCreator = {
  type?: string;
  payload?: IScheduleLocationState;
};

export type IScheduleProjectCreator = {
  type?: string;
  payload?: IScheduleProjectsState;
};

export type IScheduleSubprojectCreator = {
  type?: string;
  payload?: IScheduleSubProjectsState;
};

export interface IEmployeeFilterRequest {
  entity_id: string;
  lead_id: string | number;
  location_id: string | number;
  project_id: string | number;
  sub_project_id: string | number;
  available?: boolean;
  date?: string;
}

export interface ICreateScheduleRequest {
  id?: number;
  entity_id: string;
  lead_id: string;
  location_id: number;
  project_id: number;
  sub_project_id: number;
  schedule_for: string;
  schedule_start_date: string;
  schedule_end_date: string;
  weekoff_type: string;
  weekoff_preferences: boolean;
  schedule_preparation_start_time: string;
  schedule_on: string;
  status: string;
  total_members_count: number;
  weekoff_limit: number;
  shift_wise_members_count: IShiftWiseMembersCount[];
  employee_ids?: string[];
  employee_with_shift_ids: any[];
  weekend_weekoff_limit: number;
  weekoff_date: string;
}

export interface IShiftWiseMembersCount {
  shift_id: number;
  shift_name: string;
  min_count: string | number;
  max_count: string | number;
}

export interface ICalendarEventsRequest {
  entity_id: string;
  created_by_id?: string | number;
  lead_id?: string | number;
  location_ids?: number[];
  location_id: string | number;
  project_id: string | number;
  sub_project_id: string | number;
  start_date: string;
  end_date: string;
}

export type IScheduleFormDetails = {
  project?: IOptionType;
  sub_project?: IOptionType;
  lead_id?: IOptionType;
  location?: IOptionType;
  customer?: IOptionType;
  location_id?: IOptionType;
  employeesList?: any[];
  shift_id?: string | number;
  employees_list?: EmployeesList[];
  locations_list?: ILocationsList[];
  projects_list?: IProjectsList[];
  team_schedule?: IScheduleDaum;
};

export interface EmployeesList {
  name: string;
  employee_id: string;
  team_id: number;
  shift_id: number;
}

export interface ITeamScheduleRequest {
  entity_id: string;
  lead_id: string | number;
  location_id: string | number;
  project_id: string | number;
  sub_project_id: string | number;
  start_date: string;
  end_date: string;
  shift_id?: string | number;
}

export interface ITeamScheduleData {
  is_locked: boolean;
  schedule_config_id: number;
  schedule_stats: IScheduleStat[];
  schedule_status: string;
  team_schedules: ITeamSchedule[];
}

export interface IScheduleStat {
  date: string;
  schedule_config_id: number;
  schedule_status: string;
  resources_count: number;
  min_resources: number;
  max_resources: number;
  weekoff_count: number;
  weekoff_limit: number;
  leave_count: number;
  schedule_data: IScheduleDaum[];
}

export interface IScheduleDaum {
  schedule_config_id: number;
  schedule_id: number;
  schedule_date: string;
  shift_start_time: string;
  shift_end_time: string;
  location_id: number;
  location_name: string;
  status: string;
}

export interface ITeamSchedule {
  employee_id: string;
  employee_name: string;
  phone_number: string;
  schedule_config_status: string;
  schedule_status: string;
  schedule: ISchedule[];
  location_id: number;
}

export interface ISchedule {
  id: number;
  entity_id: string;
  status: string;
  schedule_config_id: number;
  schedule_id: number;
  schedule_date: string;
  employee_id: string;
  project_id: number;
  sub_project_id: number;
  location_id: number;
  customer_id: number;
  shift_start_time: string;
  shift_end_time: string;
  on_week_off: boolean;
  on_leave: boolean;
  pending_leave: boolean;
  created_at: string;
  updated_at: string;
  employee_name: string;
  phone_number: string;
  project_name: string;
  sub_project_name: string;
  location_name: string;
  customer_name: string;
  schedule_config_status: string;
  schedule_status: string;
}

export interface IWeekoffRemark {
  status: string;
  employee_id: string;
  employee_name: string;
  weekoff_reason: string;
}

export interface ILeaveRemark {
  status: string;
  leave_type: string;
}

export interface IAddResourceRequest {
  entity_id: string;
  schedule_config_id: number;
  lead_id: string | number;
  location_id: string | number;
  project_id: string | number;
  sub_project_id: string | number;
  schedule_date: string;
  employee_with_shift_ids: IEmployeeWithShiftId[];
}

export interface IEmployeeWithShiftId {
  employee_id: string;
  shift_id: number;
}

export interface ICalendarEventsData {
  date_wise_leaves_count: IDateWiseLeavesCount[];
  shift_wise_counts: IShiftWiseCount[];
  weekoff_preferences: IWeekoffPreference[];
}

export interface IDateWiseLeavesCount {
  date: string;
  is_leaves: boolean;
  count: number;
}

export interface IShiftWiseCount {
  schedule_date: string;
  is_shifts: boolean;
  shifts: IShift[];
}

export interface IShift {
  shift_id: number;
  shift_type: string;
  count: number;
  total_count: number;
}

export interface IWeekoffPreference {
  date: string;
  is_weekoff_preference: boolean;
  count: number;
  total_count: number;
}

export interface IWeekoffUpdate {
  weekoff_request_id: number;
  swapped_with: string;
  swapped_with_name: string;
  approved_by: string;
  approved_by_name: string;
  status: string;
}

export interface IWeekOffList {
  weekoff_request_id: number;
  requested_weekoff_date: string;
  requested_by: string;
  requested_by_name: string;
  status: string;
  requested_to_multiple: boolean;
}

export interface IWeekOffData {
  weekoff_swap_request_id: number;
  requested_weekoff_date: string;
  requested_by_me: string;
  requested_by_name: string;
  status: string;
  requested_to: IRequestedTo[];
  approver: IApprover;
  reason: string;
}

export interface IRequestedTo {
  id: string;
  name: string;
  status: string;
}

export interface IApprover {
  id: string;
  name: string;
  status: string;
}

export interface IResourceFilterList {
  employees_list: IEmployeesList[];
  locations_list: ILocationsList[];
}

export interface IEmployeesList {
  employee_id: string;
  employee_name: string;
  shift_id: number;
  schedule_start_date: string;
  schedule_end_date: string;
  schedule_status: string;
}

export interface ILocationsList {
  location_id: number;
  location_name: string;
}

export interface IAddResourceFilterRequest {
  entity_id: string;
  team_id: number;
  location_id: number;
  start_date: string;
  end_date: string;
}

export interface IProjectsList {
  project_id: number;
  project_name: string;
}

export interface ICountResponse {
  leaves_count: number;
  weekoffs_count: number;
}

export interface IChangeWeekOffRequest {
  employee_id: string;
  lead_id: string;
  lead_name: string;
  weekoff_date: string;
  updated_weekoff_date: string;
  weekoff_reason: string;
}

export interface IRemoveResourcesRequest {
  schedule_config_id: number;
  employee_ids: string[];
}

export interface IScheduleList {
  schedule_config_id: number;
  schedule_start_date: string;
  schedule_end_date: string;
  schedule_for: string;
  weekoff_type: string;
  schedule_preparation_start_time: string;
  schedule_on: string;
  status: string;
}

export interface IScheduleDetails {
  employees_list: string[];
  schedule_config_data: IScheduleConfigData;
  shift_wise_members_count: IShiftWiseMembersCount[];
  total_members_count: number;
  weekoff_limit: number;
  min_count: number;
  max_count: number;
  is_ops_lead: boolean;
}

export interface IScheduleConfigData {
  id: number;
  entity_id: string;
  lead_name: string;
  lead_id: string;
  location_id: number;
  project_id: number;
  sub_project_id: number;
  schedule_for: string;
  schedule_start_date: string;
  schedule_end_date: string;
  weekoff_type: string;
  weekoff_date: string;
  weekoff_preferences: boolean;
  schedule_preparation_start_time: string;
  schedule_on: string;
  status: string;
  created_by: string;
  is_locked: boolean;
  shift_id: number | string;
  task: string;
  customer_id: string | number;
  customer_name: number;
  location_name: string;
  project_name: string;
  sub_project_name: string;
  shift_name: string;
  shift_start_time?: any;
  shift_end_time?: any;
  // min_count: number;
  // max_count: number;
}

export interface IUnScheduledEmployeeList {
  employee_id: string;
  employee_name: string;
  date_wise_status: IStatus[];
}

export interface IStatus {
  date: string;
  status: string;
}
